import {AbstractService} from "./abstract.service";

export class ShipperServices extends AbstractService {

  static get entity() {
    return "n360/inte"
  }
  
  static get entityPartner() {
    return "nsh/partner/api"
  }

  static get URL_GATEWAY() {
    return process.env.VUE_APP_GATEWAY_API_URL;
  }
  
  static async getListShipper(params) {
    try {
      const response = await this.callApi().post( `${this.entity}/api/dlo/shipper/search-page`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async createShipper(params) {
    try {
      const response = await this.callApi().post( `${this.entity}/api/dlo/shipper`, params);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getListPartnerShipper(param) {
    try {
      const response = await this.callApi().post( `${this.entityPartner}/partners/shippers`, param);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async createNewShipper(param) {
    try {
      const response = await this.callApi().post(
        `${this.entityPartner}/partners/shippers/create`,
        param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async getShipperById(param) {
    try {
      const response = await this.callApi().post(`${this.entityPartner}/partners/shippers/detail`, param);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateShipperv2(param) {
    try {
      const response = await await this.callApi().put(
        `${this.entityPartner}/partners/shippers/edit/${param.id}`, param.param
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async deleteShipper(param) {
    try {
      const response = await this.callApi().delete(
        `${this.entityPartner}/partners/shippers/delete`, {
          data: param
        }
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }

  static async updateShipper(params) {
    try {
      const response = await await this.callApi().put(
        `${this.entity}/api/dlo/shipper`, params
      );
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
  static async removeShipper(shipperId) {
    try {
      const response = await this.callApi().delete(`${this.entity}/api/dlo/shipper/${shipperId}`);
      return this.responseWrapper(response, response.data.data);
    } catch (error) {
      const message = "Error";
      throw this.errorWrapper(error, message);
    }
  }
}
